export const assistantMessages = [
  <div key="1">
    <p className="mb-3">
      Certainly! Here&apos;s a summary of five creative ways to use your
      kids&apos; art:
    </p>
    <ol className="space-y-2">
      <li>
        <strong>Create Art Books:</strong> Turn scanned artwork into custom
        photo books.
      </li>
      <li>
        <strong>Set Up a Gallery Wall:</strong> Use a dedicated wall with
        interchangeable frames for displaying art.
      </li>
      <li>
        <strong>Make Functional Items:</strong> Print designs on items like
        pillows, bags, or mugs.
      </li>
      <li>
        <strong>Implement an Art Rotation System:</strong> Regularly change the
        displayed art, archiving the older pieces.
      </li>
      <li>
        <strong>Use as Gift Wrap:</strong> Repurpose art as unique wrapping
        paper for presents.
      </li>
    </ol>
  </div>,
  <div key="2">
    <p className="mb-3">
      Of course! Here are five more creative suggestions for what to do with
      your children&apos;s art:
    </p>
    <ol className="space-y-2">
      <li>
        <strong>Create a Digital Archive:</strong> Scan or take photos of the
        artwork and save it in a digital cloud storage service for easy access
        and space-saving.
      </li>
      <li>
        <strong>Custom Calendar:</strong> Design a custom calendar with each
        month showcasing a different piece of your child&apos;s art.
      </li>
      <li>
        <strong>Storybook Creation:</strong> Compile the artwork into a
        storybook, possibly with a narrative created by your child, to make a
        personalized book.
      </li>
      <li>
        <strong>Puzzle Making:</strong> Convert their artwork into a jigsaw
        puzzle for a fun and unique pastime activity.
      </li>
      <li>
        <strong>Home Decor Items:</strong> Use the artwork to create home decor
        items like coasters, magnets, or lampshades to decorate your house.
      </li>
    </ol>
  </div>,
];

export const userMessages = [
  "What are 5 creative things I could do with my kids' art? I don't want to throw them away, but it's also so much clutter.",
  "I didn't like the suggestions. Can you give me some more?",
];
